import React, { useEffect, useState } from 'react'
import { getVisitStats } from '../../requests/visit';
import classes from './styles.module.scss';

const firstDayOfCurrentMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
const lastDayOfCurrentMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

const StatsPage = () => {
  const [date, setDate] = useState<{
    from: Date | null;
    to: Date | null;
  }>({
    from: firstDayOfCurrentMonth,
    to: lastDayOfCurrentMonth
  });
  const [list, setList] = useState<{ visitDate: string, visitCount: number }[]>([]);

  useEffect(() => {
    if (!date.from || !date.to) return;
    const from = date.from;
    const to = date.to;

    getVisitStats(from.toISOString().split('T')[0], to.toISOString().split('T')[0]).then((stats: any) => {
      setList(stats.list)
    });
  }, [date])
  return (
    <div className={classes.stats}>
      <div className={classes.stats__filters}>
        <input
          type="date"
          name="from"
          id="from"
          value={date.from?.toISOString().split('T')[0]}
          onChange={e => setDate({ ...date, from: new Date(e.target.value) })}
          max={date.to?.toISOString().split('T')[0] || ''}
        />
        <input
          type="date"
          name="to"
          id="to"
          value={date.to?.toISOString().split('T')[0]}
          onChange={e => setDate({ ...date, to: new Date(e.target.value) })}
          min={date.from?.toISOString().split('T')[0] || ''}
        />
      </div>

      <table className={classes.stats__list}>
        <thead>
          <tr>
            <th>Дата</th>
            <th>Количество посещений</th>
          </tr>
        </thead>
        <tbody>
          {list.map(item => (
            <tr key={item.visitDate} className={classes.stats__item}>
              <td>{item.visitDate}</td>
              <td>{item.visitCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default StatsPage